function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41.294H.426C.196.294 0 .5 0 .74v7.119c0 .24.196.445.425.445h1.146c.196 0 .36.17.36.342l-.033 1.06L3.96 8.372c.065-.034.13-.068.196-.068h4.255a.45.45 0 00.458-.445V.739a.45.45 0 00-.458-.445zM1.539 6.42c-.196 0-.327-.17-.327-.342 0-.205.13-.342.327-.342h3.633c.164 0 .327.137.327.342 0 .171-.163.342-.327.342H1.538zm0-1.78c-.196 0-.327-.136-.327-.342 0-.17.13-.342.327-.342h4.647c.197 0 .328.171.328.342 0 .206-.131.343-.328.343H1.538zm0-1.745c-.196 0-.327-.17-.327-.342 0-.205.13-.342.327-.342h5.793c.196 0 .327.137.327.342 0 .171-.13.342-.327.342H1.538z",
  fill: "#CC9437",
  fillRule: "nonzero"
});

function SvgMemoriaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoriaIcon);
export default __webpack_public_path__ + "static/media/memoria-icon.42510724.svg";
export { ForwardRef as ReactComponent };